import React from 'react';
import styled from 'react-emotion';
import PropTypes from 'prop-types';
import { WHITE, YELLOW } from 'govuk-colours';

var asTopNavAnchor = function asTopNavAnchor(AnchorType) {
  var Anchor = function Anchor(props) {
    return React.createElement(AnchorType, props, props.children);
  };

  var StyledHoc = styled(Anchor)({
    color: WHITE,
    // TODO: active state, LIGHT_BLUE
    textDecoration: 'none',
    textDecorationSkipInk: 'none',
    borderBottom: '1px solid transparent',
    fontWeight: 700,
    lineHeight: 1,
    ':hover': {
      borderBottomColor: WHITE // TODO: active state, LIGHT_BLUE

    },
    ':focus': {
      outline: "3px solid " + YELLOW
    }
  });
  return StyledHoc;
};

export default asTopNavAnchor;
//# sourceMappingURL=asTopNavAnchor.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/top-nav/es/hoc/asTopNavAnchor.js
// module id = 304
// module chunks = 0